import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useSelector } from 'react-redux';

import { getAccessToken } from '@/utils/api';

import { makeAPIRequestReactQueryWithHeaders } from '../api';
import { endpoints } from '../endpoints';

export interface SetVoiceNoteFieldRequiredResponse {
  required: boolean;
}

export const useSetVoiceNoteFieldRequired = () => {
  const queryClient = useQueryClient();
  const { primaryPracticeId: practiceId, primaryOrganizationId: orgId } =
    useSelector(
      (state: {
        login: {
          user: { primaryPracticeId?: string; primaryOrganizationId?: string };
        };
      }) => state.login.user,
    );

  return useMutation({
    mutationFn: async ({
      fieldKey,
      required,
    }: {
      fieldKey: string;
      required: boolean;
    }) => {
      const token = getAccessToken();
      return makeAPIRequestReactQueryWithHeaders<SetVoiceNoteFieldRequiredResponse>(
        `/${endpoints.ambient.voiceNotes.required(fieldKey)}`,
        {},
        {
          practice: practiceId,
          org: orgId,
          ...(token ? { Authorization: `Bearer ${token}` } : {}),
        },
        'PATCH',
        {
          data: { required },
        },
      );
    },
    onSuccess: () => {
      void queryClient.invalidateQueries({ queryKey: ['voice-note-fields'] });
    },
  });
};
